import axios from 'axios';
import { INVOICES_FETCH } from './types';

export default {
  [INVOICES_FETCH]: async ({ commit }, payload) => {
    const { context, params } = payload;
    const response = await axios.get(`/api/${context}/invoices`, { params });

    commit(INVOICES_FETCH, response.data);
  },
};
